import { getIntl } from "context/SettingsProvider";
import technicianSettings from "helpers/technicianSettings";
import * as yup from "yup";

export const TechnicianSignoffValidationSchema = () => {
  const intl = getIntl();
  return yup.object({
    solutionDescription: yup.string(),
    skipSignature: yup.boolean(),
    customerSignerName: yup.string().test({
      name: "required",
      message: intl.formatMessage({ id: "visit.customerSignerNameRequired" }),
      test: function (value) {
        return technicianSettings.requireCustomerSignatureName ? !!value : true;
      },
    }),
    // customerSignature does not get saved until form submit
    // so it is not validated here on purpose
    signatureEngineer: yup.string().test({
      name: "required",
      message: intl.formatMessage({ id: "visit.engineerSignatureRequired" }),
      test: function (value) {
        return technicianSettings.requireTechnicianSignature ? !!value : true;
      },
    }),
    reference: yup
      .string()
      .nullable()
      .test({
        name: "required",
        message: intl.formatMessage({ id: "visit.reference" }),
        test: function (value) {
          return technicianSettings.requireReference ? !!value : true;
        },
      }),
  });
};
